import { render, staticRenderFns } from "./XF.vue?vue&type=template&id=cc7ddeb2&scoped=true&"
import script from "./XF.vue?vue&type=script&lang=js&"
export * from "./XF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7ddeb2",
  null
  
)

export default component.exports